import { Box, Button, Container, Stack, Typography, useTheme } from "@mui/material";
import Lottie from "react-lottie-player";
import { useNavigate, useSearchParams } from "react-router-dom";
import errorAnimation from "assets/lotties/newError.json";
import { useEffect, useState } from "react";

const errorMap = {
  "noWs": {
    heading: "Workspace not found",
    message: "The workspace you are trying to access does not exist or you do not have access to it.",
  },
  "default": {
    heading: "Oops!",
    message: "Something went wrong",
  }
} as const;

const ErrorElement = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [queryParams, setQueryParams] = useSearchParams();
  const errorType = queryParams.get("errorType") as keyof typeof errorMap;
  const [errorReason, setErrorReason] = useState<string>("Something went wrong");

  const { heading, message } = errorMap[errorType ?? "default"];

  useEffect(() => {
    // Get error message from router state if available
    const state = window.history.state?.usr;
    if (state?.errorMessage) {
      setErrorReason(state.errorMessage);
    }
  }, []);

  return (
    <Container maxWidth="lg">
      <Stack 
        direction={{ xs: "column", md: "row" }}
        spacing={{ xs: 4, md: 8 }}
        alignItems="center" 
        justifyContent="center" 
        height="100vh"
        sx={{
          textAlign: { xs: "center", md: "left" },
          px: 2
        }}
      >
        <Box sx={{ maxWidth: { xs: 250, md: 300 }, width: "100%" }}>
          <Lottie
            loop
            animationData={errorAnimation}
            play
            style={{ width: "100%", height: "100%" }}
          />
        </Box>
        
        <Box>
          <Typography variant="h2" fontWeight="bold" color="white" gutterBottom>
            {heading}
          </Typography>
          <Typography variant="h4" color="text.secondary" sx={{ maxWidth: 500, textWrap: "balance", mb: 4 }}>
            {message}
          </Typography>
          {/* { errorReason && <Typography variant="body1" color="text.secondary" sx={{ mb: 4, maxWidth: 500 }}>
            {errorReason}
          </Typography> } */}
          <Stack 
            direction={{ xs: "column", sm: "row" }} 
            spacing={2} 
            justifyContent={{ xs: "center", md: "flex-start" }}
          >
            <Button 
              variant="contained" 
              color="primary" 
              onClick={() => navigate(-1)}
              sx={{
                borderRadius: 2,
                px: 3,
                py: 1.5,
                fontWeight: "bold",
                boxShadow: theme.shadows[4],
                width: { xs: "100%", sm: "auto" }
              }}
            >
              Go Back
            </Button>
            <Button 
              variant="outlined" 
              onClick={() => navigate("/")}
              sx={{
                borderRadius: 2,
                px: 3,
                py: 1.5,
                fontWeight: "bold",
                width: { xs: "100%", sm: "auto" }
              }}
            >
              Go Home
            </Button>
          </Stack>
        </Box>
      </Stack>
    </Container>
  );
};

export default ErrorElement;